import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { Label } from 'shared/atoms'
import { Field, fieldButtonClassName } from './Field'
import { Position, usePlacement } from '../placement'

type ImageProps = {
	floormapConfig: any[]
	onSubmit: (data: any) => void
}

export const ImageEl = ({ floormapConfig, onSubmit }: ImageProps) => {
	const { t } = useTranslation()
	const { handleSubmit, register } = useForm({
		mode: 'onChange'
	})

	const submitImage = ({ images }: any, position: Position = { x: 45, y: 70 }) => {
		const reader = new FileReader()
		reader.onloadend = () => {
			const image = new Image()

			const base64String = reader.result!.toString()

			image.src = reader.result as string

			image.onload = () => {
				const { width, height } = image

				onSubmit([
					...floormapConfig,
					{
						type: 'image',
						src: base64String,
						width,
						height,
						rotation: 0,
						draggable: true,
						id: crypto.randomUUID(),
						...position
					}
				])
			}
		}
		try {
			reader.readAsDataURL(images[0])
		} catch (err) {
			console.log(err)
		}
	}

	usePlacement('image', (position) => handleSubmit((data) => submitImage(data, position))())

	return (
		<Field label={t('Image')} section="image" isPlaceable>
			<form className="space-y-2" onSubmit={handleSubmit((data) => submitImage(data))}>
				<div className="flex flex-col gap-y-1.5">
					<Label htmlFor="floor-map-image" text={t('Image')} />
					<input
						id="floor-map-image"
						type="file"
						accept="image/*"
						className="block w-full text-[12px] text-muted-foreground file:mr-3 file:cursor-pointer file:rounded-md file:border-0 file:bg-muted file:px-3 file:py-2 file:text-[12px] file:font-medium file:text-foreground hover:file:bg-border"
						{...register('images')}
					/>
				</div>
				<button type="submit" className={fieldButtonClassName}>
					{t('Add image')}
				</button>
			</form>
		</Field>
	)
}
